@if (result.visibility) {
    <div [id]="'container-check-password-'+environment.data.brand" class="container-check-password">
        <div id="check-password-form">
            <span class="close-icon" aria-hidden="true" (click)="close()">&times;</span>
            <div class="row w-100 pl-3 pb-3 text-center">
                <div class="bold-text align-content-center w-100 pb-3 nudge-right blue-color">Veuillez saisir votre mot
                    de passe
                </div>
                <div class="col-12">
                    <div>
                        <label>
                            <span class="bold-label-text float-left">Mot de passe* :</span>
                            <input type="password" class="form-control" placeholder="Mot de passe"
                                   [(ngModel)]="password">
                            <a class="showPassword" href="#" id="togglePass"
                               (click)="togglePasswordService.toggle($event)">Voir</a>
                        </label>
                        @if (result.isValid === false) {
                            <div class="row w-100 ml-2 form-text error-message">Mot de passe invalide.</div>
                        }
                    </div>
                    <button type="button" class="cta_btn level_2" (click)="submit()">Valider<span></span></button>
                </div>
            </div>
        </div>
    </div>
}
